import { applyMiddleware, combineReducers, createStore } from 'redux';

import { apiMiddleware, logger } from '@/redux/middleware/index';
import { authReducer, loadingReducer, routeReducer, themeReducer } from '@/redux/reducers/index';

const reducer = combineReducers({
    auth: authReducer,
    theme: themeReducer,
    loading: loadingReducer,
    route: routeReducer,
});

const store = createStore(reducer, applyMiddleware(apiMiddleware(), logger()));

export default store;
